import { defineComponent, onMounted } from 'vue';
export default defineComponent({
  name: 'newsmain',
  setup: function setup() {
    onMounted(function () {
      window.scrollTo(0, 0);
    });
    return {};
  }
});